export default function AlertErrorMessage({ message, onClose }) {
  if (!message) return null

  return (
    <div
      className="alert alert-danger d-flex justify-content-between align-items-center"
      role="alert"
    >
      <div>
        <svg
          width="19"
          height="16"
          viewBox="0 0 19 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="warning-route-plan-icon"
        >
          <path d="M9.16667 0.166992L0 16.0003H18.3333L9.16667 0.166992Z" fill="#FEC047" />
          <path d="M9.16563 3.49219L15.4406 14.3339H2.89062L9.16563 3.49219Z" fill="#FEC047" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.33398 6.83398H10.0007V10.1673H8.33398V6.83398ZM8.33398 11.834H10.0007V13.5007H8.33398V11.834Z"
            fill="#202020"
          />
        </svg>
        <strong>{message}</strong>
      </div>
      <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
    </div>
  )
}